import { render } from "./AlertPop.vue?vue&type=template&id=79a46585"
import script from "./AlertPop.vue?vue&type=script&lang=js"
export * from "./AlertPop.vue?vue&type=script&lang=js"

import exportComponent from "D:\\新建文件夹 (2)\\前端\\新建文件夹\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__